import React from 'react';

import ShopAndFly404 from './ShopAndFly404';

const ErrorPage404 = () => {
  return <ShopAndFly404 />;
};
export default ErrorPage404;
